// ------ ( Newslatter Popup Start ) ------
$(document).ready(function () {
   $(document).find(".popup_button").click(function(){
      $(".custom-email-popup .newsletter-popup").attr("open", "");
   }); 
   $('.signUp-popup-btn').on( "click", function() {
      $(".custom-email-popup .newsletter-popup").attr("open", "");
   });

    if ($(".custom-email-popup .newsletter-popup").hasClass("success")) {
      setTimeout(function () {
         window.location.href = window.location.origin + "/";
      }, 4500);
   }
});
// ------ ( Newslatter Popup End ) ------   